var React = require('react');

function Degrees (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"strokeWidth":"6","stroke":"black","points":"0,2000 1000,2000 1000,0 "}));
}

Degrees.defaultProps = {"overflow":"visible","focusable":"false","viewBox":"0 0 1000 2000"};

module.exports = Degrees;

Degrees.default = Degrees;
